<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Performance Journals</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Performance Journals</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex justify-content-between">
                    <h4 class="card-title mb-0">Perfomance Journals</h4>
                    <div class="col-auto float-right ml-auto">
                      <router-link
                        to="/add-performance-journal"
                        class="btn add-btn"
                        ><i class="fa fa-plus"></i>Add Journal</router-link
                      >
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <!----Datatable-->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <v-data-table
                          :headers="headers"
                          :items="journals"
                          sort-by=""
                          class="elevation-1"
                        >
                          <template v-slot:[`item.profile`]="{ item }">
                            <h2 class="table-avatar blue-link">
                              <router-link
                                :to="{
                                  name: 'employeedetail',
                                  params: { id: item.employee.id }
                                }"
                                class="avatar"
                                ><img
                                  alt=""
                                  src="~@/assets/profiles/avatar-02.jpg"
                                  v-if="!item.employee.passportPhoto"/>
                                <img
                                  alt=""
                                  :src="media + item.employee.passportPhoto"
                                  width="38"
                                  v-if="item.employee.passportPhoto"
                              /></router-link>
                              <router-link
                                :to="{
                                  name: 'employeedetail',
                                  params: { id: item.employee.id }
                                }"
                                >{{
                                  `${item.employee.firstName} ${item.employee.lastName}`
                                }}</router-link
                              >
                            </h2>
                          </template>
                          <template v-slot:[`item.journal`]="{ item }">
                            {{
                              item.journalDate
                                ? new Date(
                                    item.journalDate
                                  ).toLocaleDateString()
                                : ""
                            }}
                          </template>
                          <template v-slot:[`item.from`]="{ item }">
                            {{
                              item.startDate
                                ? new Date(item.startDate).toLocaleDateString()
                                : ""
                            }}
                          </template>
                          <template v-slot:[`item.to`]="{ item }">
                            {{
                              item.dateCompleted
                                ? new Date(
                                    item.dateCompleted
                                  ).toLocaleDateString()
                                : ""
                            }}
                          </template>
                          <template v-slot:[`item.Source`]="{ item }">
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.source == 0"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-purple"></i>
                              Manager Journal
                            </a>
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.source == 1"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-success"></i> My
                              Journal
                            </a>
                            <a
                              class="btn btn-white btn-sm btn-rounded"
                              v-if="item.source == 2"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-danger"></i>
                              Performance Feedback
                            </a>
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <div class="dropdown dropdown-action">
                              <a
                                href="#"
                                class="action-icon dropdown-toggle"
                                data-toggle="dropdown"
                                aria-expanded="false"
                                ><i class="material-icons">more_vert</i></a
                              >
                              <div class="dropdown-menu dropdown-menu-right">
                                <router-link
                                  :to="{
                                    name: 'editjournal',
                                    params: { id: item.id }
                                  }"
                                  class="dropdown-item"
                                  ><i class="fa fa-pencil m-r-5"></i>
                                  Edit</router-link
                                >
                                <a class="dropdown-item"
                                  ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                                >
                              </div>
                            </div>
                          </template>
                        </v-data-table>
                      </div>
                    </div>
                  </div>
                  <!---/Datatable-->
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
        </div>
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete</h3>
                <p>Are you sure want to delete this?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a class="btn btn-primary continue-btn" data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a class="btn btn-primary cancel-btn">Cancel</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { performanceService } from "@/services/performanceService";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      dialogDelete: false,
      headers: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },
        { text: "Title", value: "title" },
        { text: "Journal Date", value: "journal" },
        { text: "Source", value: "Source" },
        { text: "Submitted By", value: "submittedBy" },
        { text: "Start Date", value: "from" },
        { text: "Date Completed", value: "to" },
        { text: "", value: "actions", sortable: false }
      ],
      employeeId: this.$route.params.id,
      company: authenticationService.currentOfficeValue,
      journals: [],
      submitted: false,
      loading: false,
      error: ""
    };
  },
  mounted() {
    this.getJornals();
    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
  },

  methods: {
    getJornals() {
      performanceService.getJournals(this.company.id).then(
        model => {
          this.journals = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    }
  },
  name: "journals"
};
</script>
<style scoped>
.datatable > thead > tr > th,
.datatable > tbody > tr > td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/performance/journals.vue